

















import { Component, Prop, Ref, Vue, Watch } from 'vue-property-decorator';
import CardTitle from '@/components/common/CardTitle.vue';
import Login from '@/views/Auth/Login.vue';
import SignUp from '@/views/Auth/SignUp.vue';
import ResetPassword from '@/views/Auth/ResetPassword.vue';

@Component({
    components: { CardTitle, Login, SignUp, ResetPassword },
})
export default class LoginRegisterDDialog extends Vue {
    @Prop({ default: false, type:Boolean})
    dialog!: boolean;

    private state = 1;

    @Watch('show')
    onChangeShow() {
        if (!this.dialog) {
            this.state = 1;
        }
    }
}
